module.exports = __webpack_public_path__ + "static/media/menu-northstar.6aca62a1.svg";